const activityTypes = {
  getActivityTypeIcon(id) {
    switch (id) {
      case this.$enums.activityTypes.ADDED:
        return "add";
      case this.$enums.activityTypes.REMOVED:
        return "close";
      case this.$enums.activityTypes.SENT:
        return "send";
      case this.$enums.activityTypes.FINISHED:
        return "check";
    }
    return "";
  }
};

export default { methods: activityTypes };
